if (!customElements.get('main-collection-header')) {
  customElements.define(
    'main-collection-header',
    class MainCollectionHeader extends HTMLElement {
      constructor() {
        super();
        this.swipers = []; // Store Swiper instances
        

        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      }

      init() {
        this.handleCardsContentRendering();
        this.initSwiper();
        this.setEqualHeightForRenderedContent();
        this.manageSwiper();
        // this.handleFilterClick();
        // Add resize event listener to handle window size changes
        window.addEventListener('resize', () => {
          this.manageSwiper();
          this.setEqualHeightForRenderedContent();
        });
      }

      manageSwiper() {
        if (window.innerWidth <= 960) {
          this.initSwiper();
        } else {
          this.destroySwipers();
        }
      }

      initSwiper() {
        if (this.swipers.length > 0) return; // Prevent reinitialization

        const swiperContainers = this.querySelectorAll('.js-myswiper');
        swiperContainers.forEach((swiperContainer) => {
          // eslint-disable-next-line no-undef
          const swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            pagination: {
              el: swiperContainer.querySelector('.swiper-pagination'),
              dynamicBullets: true
            },
          });
          this.swipers.push(swiper); // Store the Swiper instance
        });
      }

      destroySwipers() {
        this.swipers.forEach((swiper) => {
          swiper.destroy(true, true);
        });
        this.swipers = []; // Clear the stored Swiper instances
      }

      setEqualHeightForRenderedContent() {
        const renderedContents = this.querySelectorAll('.main-collection-header__rendered-content');
        let maxHeight = 0;

        if (window.innerWidth > 960) {
          // Set heights to 'auto' for larger screens
          renderedContents.forEach((content) => {
            const element = content;
            element.style.height = 'auto';
          });
        } else {
          // Temporarily display all elements if hidden
          renderedContents.forEach((content) => {
            const element = content;
            element.style.height = '';
            element.style.display = 'flex';
          });

          // Calculate the max height
          renderedContents.forEach((content) => {
            const contentHeight = content.offsetHeight;
            if (contentHeight > maxHeight) {
              maxHeight = contentHeight;
            }
          });

          // Apply the max height to all rendered contents and restore visibility
          renderedContents.forEach((content) => {
            const element = content;
            element.style.height = `${maxHeight}px`;
            element.style.display = '';
          });
        }
      }

      static toggleActiveClass(elements, activeIndex, activeClass) {
        elements.forEach((element, index) => {
          if (index === activeIndex) {
            element.classList.add(activeClass);
          } else {
            element.classList.remove(activeClass);
          }
        });
      }

      handleCardsContentRendering() {
        const cards = this.querySelectorAll('.main-collection-header__card');
        cards.forEach((card, index) => {
          card.addEventListener('click', () => {
            const selectedCollectionHandle = card.getAttribute("data-handle");
            // 1. Render content
            const renderContents = this.querySelectorAll('.main-collection-header__rendered-content');
            MainCollectionHeader.toggleActiveClass(cards, index, 'main-collection-header__card--active');
            MainCollectionHeader.toggleActiveClass(
              renderContents,
              index,
              'main-collection-header__rendered-content--active'
            );
            const oldProductsGrid = document.querySelector('.main-collection-product-grid__container');
            const oldFilter = this.querySelector(".filter__container");
            this.fetchCollection(selectedCollectionHandle)
            .then((data) => {
              if (data) {
                // Parse the returned HTML and replace the relevant section content
                const parser = new DOMParser();
                const mainCollectionProductGrid = parser.parseFromString(data['main-collection-product-grid'], 'text/html');
                const mainCollectionHeader = parser.parseFromString(data['main-collection-header'], 'text/html');
                const productsGrid = mainCollectionProductGrid.querySelector('.main-collection-product-grid__container');
                const newFilter = mainCollectionHeader.querySelector(".filter__container");

                if (productsGrid) {
                  oldProductsGrid.innerHTML = productsGrid.innerHTML; // Replace the content
                  // Init the FacetFiltersForm
                  FacetFiltersForm.filterData = [];
                  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
                  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
                  FacetFiltersForm.setListeners();
                  FacetFiltersForm.handleAccordeonClick();
                  FacetFiltersForm.attachFacetRemoveListeners();
                  FacetFiltersForm.initDropdownOption();
                }
                if(newFilter){
                  oldFilter.innerHTML = newFilter.innerHTML;
                  // this.handleFilterClick();
                }
                // Update URL without reloading
                window.history.pushState({}, '', `/collections/${selectedCollectionHandle}`);
              }
            })
            .catch((error) => {
              console.error('Failed to fetch collection:', error);
            });
          });
        });
      }

      async fetchCollection(collectionHandle) {
        try {
          const response = await fetch(`/collections/${collectionHandle}?sections=main-collection-header,main-collection-product-grid`);
          // Log the response text for debugging
          const text = await response.text(); // Get the response as text
          const data = JSON.parse(text); // Now parse the text as JSON
          return data; // Return the JSON object
        } catch (error) {
          console.error('Failed to fetch collection:', error);
          return null;
        }
      }

      // handleFilterClick() {
      //   const filters = this.querySelectorAll('.filter__list-filters-item');
      //   filters.forEach((filter, index) => {
      //     filter.classList.remove("filter__list-filters-item--active");
      //     filter.addEventListener('click', () => {
      //       this.products = document.querySelector("#product-json") ?   JSON.parse(document.querySelector("#product-json").innerHTML) : JSON.parse(this.querySelector('#p-json').innerHTML);
      //       const cards = document.querySelectorAll('.grid__item.product-card__item');
      //       const isActive = filter.classList.contains('filter__list-filters-item--active');
          
      //       if (isActive) {
      //         // If the filter is already active, reset all cards and remove the active filter
      //         cards.forEach((card) => {
      //           const tempCard = card;
      //           tempCard.style.display = 'flex'; // Show all cards
      //         });
      //         filters.forEach((f) => {
      //           f.classList.remove('filter__list-filters-item--active');
      //         });
      //       } else {
      //         // Toggle active class on filter items
      //         MainCollectionHeader.toggleActiveClass(filters, index, 'filter__list-filters-item--active');

      //         // Get the clicked filter name (tag) and convert it to lowercase
      //         const selectedTag = filter.textContent.trim().toLowerCase();

      //         // Filter products that match the selected tag (case-insensitive)
      //         const matchingProducts = this.products.filter((product) => {
      //           // Convert product tags to lowercase and check if any tag matches the selected tag
      //           const productTags = product.data.tags.map((tag) => tag.toLowerCase());
      //           return productTags.includes(selectedTag);
      //         });

      //         cards.forEach((card) => {
      //           const tempCard = card;
      //           let hasMatch = false;
      //           matchingProducts.forEach((p) => {
      //             // eslint-disable-next-line eqeqeq
      //             if(p.data.id == card.querySelector('.product_card__container').getAttribute('product-id')){
      //               hasMatch = true;
      //             }
      //           })
      //           if (hasMatch) {
      //             tempCard.style.display = 'flex'; // Show matching cards
      //           } else {
      //             tempCard.style.display = 'none'; // Hide non-matching cards
      //           }
      //         });
      //       }
      //     });
      //   });
      // }
    }
  );
}